import React from 'react';
import ReactDOM from 'react-dom/client';

// Chart.js 전역 설정 (lazy loading 환경에서 필수 - App보다 먼저 로드)
import './config/chartConfig';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);